import React from 'react'

import TeacherSpeak from '../sections/teacher-speak'

export default function LanguageFilters () {
  return (
    <div className='all-filters-content'>
      <TeacherSpeak />
    </div>
  )
}
